// FLAGS: none
// Label/description/error wrapper around a single form control.
import { ReactNode, useId } from "react";

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  /** Render-prop so the control can wire the generated id for the label. */
  children: (props: { id: string; invalid: boolean }) => ReactNode;
}

/** Label + control + inline error, sharing one generated id for a11y. */
const FormField = ({
  label,
  required = false,
  error,
  children,
}: FormFieldProps) => {
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="flex items-center gap-1 text-sm font-medium text-gray-800"
      >
        {label}
        {required && (
          <span className="text-red-600" aria-hidden>
            *
          </span>
        )}
      </label>
      {children({ id, invalid: Boolean(error) })}
      {error && (
        <p role="alert" className="text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;
